import React, { useState, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

function LastPriceModal(props) {
  const lastPrice = props.model;
  const [dataChanging, setDataChanging] = useState(lastPrice);

  const title = useMemo(() => {
    if(lastPrice === undefined || lastPrice === null){
      return 'Último precio';
    }
    if(lastPrice.ItemName === undefined){
      return 'Último precio';
    }

    return `${lastPrice.ItemName}`;
  }, [lastPrice]);

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  return (
    <Modal
      title={title}
      model={lastPrice}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/purchase-price"
    >
      <TextField
        label="Precio original"
        fullWidth
        type="number"
        margin="normal"
        defaultValue={lastPrice.price || ''}
        disabled
      />
      <TextField
        label="Precio"
        fullWidth
        type="number"
        name="purchase_price"
        margin="normal"
        defaultValue={lastPrice.purchase_price || ''}
        required
        inputProps={{
          step: '0.000001',
        }}
      />
    </Modal>
  );
}

export default LastPriceModal;
